export default "__VITE_ASSET__DFT0JcVF__"